import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Autocomplete, TextField, Box, Button } from "@mui/material";
import {
  getEmpresasFabricantes,
  transferirModelos,
} from "../../../api/acaoApi";
import TransferList, { Modelo } from "../../../components/TransferList";
import { EmpresaFabricante, Fabricante } from "../../../types/acao";
import { buscaModelo } from "../../../types/modelo";

const TransferirAcao: React.FC = () => {
  const [empresasFabricantes, setEmpresasFabricantes] = useState<
    EmpresaFabricante[]
  >([]);
  const [empresaOrigem, setEmpresaOrigem] = useState<EmpresaFabricante | null>(
    null
  );
  const [empresaDestino, setEmpresaDestino] =
    useState<EmpresaFabricante | null>(null);
  const [origemModelos, setOrigemModelos] = useState<buscaModelo[]>([]);
  const [destinoModelos, setDestinoModelos] = useState<buscaModelo[]>([]);
  const [destinoModelosExistentes, setDestinoModelosExistentes] = useState<
    buscaModelo[]
  >([]);
  const [transferredItems, setTransferredItems] = useState<Modelo[]>([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          throw new Error("Token não encontrado");
        }
        const empresasfabricantesData = await getEmpresasFabricantes(token);
        setEmpresasFabricantes(empresasfabricantesData);
      } catch (error) {
        toast.error("Erro ao buscar empresas fabricantes!");
        console.error("Erro ao buscar empresas fabricantes:", error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (empresaOrigem) {
      const origemFabricantes = empresaOrigem.fabricantes.flatMap(
        (fab: Fabricante) => fab.modelos
      );
      if (empresaDestino) {
        // const destinoModelosNomes = new Set(
        //   empresaDestino.fabricantes.flatMap((fab: any) =>
        //     fab.modelos.map((mod: any) => mod.descricao_modelo)
        //   )
        // );
        // setOrigemModelos(
        //   origemFabricantes.filter(
        //     (modelo: any) => !destinoModelosNomes.has(modelo.descricao_modelo)
        //   )
        // );
      } else {
        setOrigemModelos(origemFabricantes);
      }
    } else {
      setOrigemModelos([]);
    }

    if (empresaDestino) {
      const destinoFabricantes = empresaDestino.fabricantes.flatMap(
        (fab: Fabricante) => fab.modelos
      );
      setDestinoModelos(destinoFabricantes);
      setDestinoModelosExistentes(destinoFabricantes);
    } else {
      setDestinoModelos([]);
      setDestinoModelosExistentes([]);
    }
  }, [empresaOrigem, empresaDestino]);

  const handleTransfer = async () => {
    const transferredIds = transferredItems.map((item) => item.id);
    const token = localStorage.getItem("token");

    if (!empresaOrigem || !empresaDestino) {
      toast.error("Por favor, selecione as empresas origem e destino.");
      return;
    }
    if (!token) {
      throw new Error("Token não encontrado");
    }

    try {
      await transferirModelos(
        token,
        empresaOrigem.id,
        empresaDestino.id,
        transferredIds
      );
      toast.success("Transferência realizada com sucesso!");
    } catch (error) {
      console.error("Erro ao realizar transferência:", error);
      toast.error(
        "Erro ao realizar transferência. Por favor, tente novamente."
      );
    }
  };

  const handleEmpresaOrigemChange = (
    event: React.SyntheticEvent,
    value: EmpresaFabricante | null
  ) => {
    setEmpresaOrigem(value);
  };

  const handleEmpresaDestinoChange = (
    event: React.SyntheticEvent,
    value: EmpresaFabricante | null
  ) => {
    setEmpresaDestino(value);
  };

  return (
    <Box sx={{ p: 3 }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 3,
        }}
      >
        <Button variant="contained" color="primary" onClick={handleTransfer}>
          Transferir
        </Button>
      </Box>
      <Autocomplete
        sx={{ mb: 3 }}
        options={empresasFabricantes}
        getOptionLabel={(option: EmpresaFabricante) => option.nome_empresa}
        onChange={handleEmpresaOrigemChange}
        renderInput={(params) => (
          <TextField {...params} label="Empresa Origem" variant="outlined" />
        )}
      />
      <Autocomplete
        sx={{ mb: 3 }}
        options={empresasFabricantes}
        getOptionLabel={(option: EmpresaFabricante) => option.nome_empresa}
        onChange={handleEmpresaDestinoChange}
        renderInput={(params) => (
          <TextField {...params} label="Empresa Destino" variant="outlined" />
        )}
      />
      {empresaOrigem && empresaDestino && (
        <TransferList
          origem={origemModelos}
          destino={destinoModelos}
          destinoModelosExistentes={destinoModelosExistentes}
          onChange={setTransferredItems}
        />
      )}
    </Box>
  );
};

export default TransferirAcao;
